module.exports = {"defaultFont":"Source Sans Pro","list":[],"webSafe":["Arial","Arial Black","Comic Sans MS","Courier New","Impact","Lucida Console","Source Sans Pro","Times New Roman","Verdana"]}


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/fonts.json
// module id = IHMx
// module chunks = 0